import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '@common/common.action';
import {
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
} from 'reactstrap';
import CheckBox from '@componentes/checkbox/checkbox.component';
import IntlMessage from "../../../helpers/intlMessage";

function EtiquetaEmLoteComponent({
	laminasParaEtiqueta,
	showModal,
	toggleModal,
	imprimirEtiquetas,
}) {
	const [laminasMarcadas, setLaminasMarcadas] = useState([]);
	const [estadoMarcarDesmarcarTodos, setOpcaoMarcarDesmarcarTodos] = useState(true);
	const [labelMarcarDesmarcarTodos, setLabelMarcarDesmarcarTodos] = useState("Desmarcar todos");

	useEffect(() => {
		const laminas = [];
		laminasParaEtiqueta.map((el) => laminas.push(el.idLamina));
		setLaminasMarcadas(laminas);
	}, []);

	const checkboxOnChange = (idLamina) => {
		const index = laminasMarcadas.findIndex((el) => el === idLamina);
		const laminas = [...laminasMarcadas];

		if (index >= 0) {
			laminas.splice(index, 1);
		} else {
			laminas.push(idLamina);
		}

		setLaminasMarcadas(laminas);
	};

	const marcarDesmarcarTudo = (marcado) =>
	{
		let laminas = [];
		let label = "Marcar todos";

		if (marcado)
		{
			laminasParaEtiqueta.map((el) => laminas.push(el.idLamina));
		}

		setLaminasMarcadas(laminas);
		setOpcaoMarcarDesmarcarTodos(marcado);
		setLabelMarcarDesmarcarTodos(label);
	}

	return (
		<Modal size="lg" isOpen={showModal} toggle={toggleModal}>
			<ModalHeader toggle={toggleModal}><IntlMessage id = "dashboards.cytology.printLabelsBatch"/></ModalHeader>
			<ModalBody>
				<Row style={{maxHeight: '280px', overflowX: 'hidden', overflowY: 'hidden'}}>
					<Col sm="4" key='0'>
						<CheckBox
							label={labelMarcarDesmarcarTodos}
							onChange={() => marcarDesmarcarTudo(!estadoMarcarDesmarcarTodos)}
							checked={estadoMarcarDesmarcarTodos}
						/>
					</Col>
				</Row>
				<Row style={{maxHeight: '280px', overflowX: 'hidden', overflowY: 'scroll'}}>
					{laminasParaEtiqueta.map((el, i) => {
						const css =
							el.finalizacao === <IntlMessage id = "dashboards.reports.pending"/>
								? ' checkbox-pendente'
								: el.finalizacao === <IntlMessage id = "dashboards.reports.inProgress"/>
									? ' checkbox-executando'
									: ' checkbox-finalizado';
						return (
							<Col sm="4" key={el.idLamina}>
								<CheckBox
									checkmarkClassName={css}
									key={i}
									label={el.lamina}
									checked={
										laminasMarcadas.findIndex(
											(laminaMarcada) => laminaMarcada === el.idLamina
										) >= 0
									}
									onChange={() => checkboxOnChange(el.idLamina)}
								/>
							</Col>
						);
					})}
				</Row>
			</ModalBody>
			<ModalFooter>
				<Button
					onClick={() => imprimirEtiquetas(laminasMarcadas)}
					disabled={laminasParaEtiqueta.length === 0 || laminasMarcadas.length === 0}
					color="primary"
				>
					<IntlMessage id = "dashboards.examDetails.confirm"/>
				</Button>
			</ModalFooter>
		</Modal>
	);
}

const mapStateToProps = (state) => ({
	impressoras: state.commonReducer.impressoras,
});

const mapDispacthToProps = (dispatch) => ({
	commonActions: bindActionCreators(commonActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispacthToProps
)(EtiquetaEmLoteComponent);



// WEBPACK FOOTER //
// ./src/pages/histologia/common/etiqueta.lote.component.js